import React from 'react'

import { NavLink } from 'react-router-dom'

import { SiteContext } from 'context/site-context'

import Discover from 'components/atoms/Discover'
import SearchForm from 'components/atoms/SearchForm'
import TopListings from 'components/atoms/TopListings'

import './index.scss'

const Hero = () => {
  const [ site ] = React.useContext(SiteContext)

  return (
    <div className="hero-landing-container">
      <div className="container">
        <h1>{site.hero?.headline}</h1>
        <p dangerouslySetInnerHTML={{ __html: site.hero?.subheadline}} />
        <SearchForm />
        <Discover />
        <TopListings />
      </div>
    </div>
  )
}

export default Hero
